export const config = (() => {
    const hostname = window.location.hostname;

    if (hostname === "localhost" ) {
        return {
            env: "local",
            baseUrl: "http://localhost:8993",
            serverBaseUrl: "http://localhost:80",
        };
    } else if (hostname === "127.0.0.1") {
        return {
            env: "local",
            baseUrl: "http://127.0.0.1:8993",
            serverBaseUrl: "http://127.0.0.1:80",
        };
    } else if (hostname === "cglaf.org") {
        return {
            env: "docker",
            baseUrl: "https://cglaf.org",
            serverBaseUrl: "https://cglaf.org",
        };
    } else if (hostname === "locatia.nz") {
        return {
            env: "production",
            baseUrl: "https://locatia.nz",
            serverBaseUrl: "https://locatia.nz",
        };
    } else if (hostname === "seamap.co.nz") {
        return {
            env: "production",
            baseUrl: "https://seamap.co.nz",
            serverBaseUrl: "https://seamap.co.nz",
        };
    } else {
        console.warn(`Unknown environment ${hostname}, defaulting to production settings.`);
        return {
            env: "production",
            baseUrl: "https://seamap.co.nz",
            serverBaseUrl: "https://seamap.co.nz",
        };
    }
})();
